
const PathDefinition={
  ROOT:                     {path: '/',                               },

  MAIN:                     {path: '/',                               },

}

export default PathDefinition